import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { Link } from "react-router-dom";
import ThemeMaker from "../../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../../utils/helper";
import { config } from "../../../utils/config";
import '../../../components/table.css';
import styles from "./issues.module.css";
import style from "../../components/Search&Options/Search&Options.module.css";
import CircularProgress from '@mui/material/CircularProgress';
import { Paginated } from "../../../components/Paginated";
import styleii from "../transaction/transaction.module.css";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { styled } from '@mui/material/styles';
import eye from "../../../icons/eye.png";
import moment from "moment";
import { AgChartsReact } from 'ag-charts-react';
import "../../../index.css";
import { PieChart } from '@mui/x-charts/PieChart';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
const { apiEndpoint, nodeapiEndpoint, baseNodeapiUrl } = config;
// console.log("apiEndpoint", apiEndpoint);
var $ = require('jquery');

const Issues = () => {
    const decoded: any = tokenDecode();
    const [issuesList, setIssuesList] = useState([]);
    const [SearchList, setSearchList] = useState([]);
    // const [stransactionList, setStransactionList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isExcelLoading, setIsExcelLoading] = useState(false);
    const [isGraphLoading, setIsGraphLoading] = useState(false);
    const [issueDate, setissueDate]: any = useState([])
    const [Fopen, setFOpen] = useState(false);
    const handleFOpen = () => setFOpen(true);
    const handleFClose = () => setFOpen(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { data } = decoded;
    let sellerProviderId = data?.seller_data?.provider_id

    const rawData = {
        seller_id: ''
    }

    const [selectedProvider, setselectedProvider]: any = useState("");
    const [issellerSelected, setissellerselected] = useState(false);
    const { permission: { category, order, product, role, seller, tax, user } } = data;
    const [sellerList, setSellerList] = useState([]);
    const current_seller_id = decoded?.data?.user?.seller_id;
    var count = 1;
    // const shipping_address = JSON.parse(_orderDetail?.shipping_address);
    const [nextstep, setnextstep] = useState(1);
const [totalPages, setTotalPages] = useState(1);
        const [currentPage, setCurrentPage] = useState(1);
        const [showPages, setShowPages] = useState(false);
        const [searchText, setSearchText] = useState("");

        useEffect(() => {
  setnextstep(1);
}, [searchText]);


useEffect(() => {
  fetchIssuesList();
}, [nextstep, searchText]);

const fetchIssuesList = async () => {
  setIsLoading(true);

  try {
    const params: any = {};

    // Normal list mode
    if (!searchText) {
      params.page = nextstep;
    }

    // Search mode
    if (searchText) {
      params.issue_id = searchText;
    }

    const res = await axios.get(
      `${nodeapiEndpoint}/get_issue`,
      {
        params, // ✅ IMPORTANT FIX
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      }
    );

    setSearchList(res.data.data);

    // pagination handling
    if (!searchText) {
      setTotalPages(res.data.pagination.totalPages);
    } else {
      setTotalPages(1);
    }

  } catch (error) {
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};



    const getfilterOption = async (optionvalue: any) => {
        setIsLoading(true);
        try {
            const providerID = current_seller_id === 1 ? "" : sellerProviderId;
            const { data } = await axios({
                url: `${nodeapiEndpoint}/countfilter`,
                data: {
                    provider_id: providerID,
                    status: optionvalue
                },
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            console.log("data", data);
            setIssuesList(data?.data?.reverse());
            // const isRootSeller = current_seller_id === 1 && decoded?.data?.user?.parent_id === 0;
            // const filteredData = isRootSeller ? data?.data : data?.data?.filter((item: any) => item.order_details.provider_id === sellerProviderId);
            // setSearchList(filteredData);
            if (current_seller_id === 1 && decoded?.data?.user?.parent_id === 0) {
                setSearchList(data?.data)
            } else {
                setSearchList(data?.data?.filter((item: any) => item.order_details.provider_id === sellerProviderId))
            }
            setIsLoading(false);
        } catch (error) {
            console.log("error", error);
            setIsLoading(false);
        }
    }






    const COLUMNS = [
        {
            Header: "Serial No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Ticket ID",
            accessor: (item: any) => (item?.issue_id),
            sticky: "left"
        },
        {
            Header: "Issues Type",
            accessor: (item: any) => (item?.issue_type),
            sticky: "left"
        },
        {
            Header: "Category",
            accessor: (item: any) => (item?.category),
            sticky: "left"
        },
        {
            Header: "Sub Category",
            accessor: (item: any) => (item?.sub_category),
            sticky: "left"
        },
        {
            Header: "Status",
            sticky: "left",
            accessor: (item: any) => (item?.status === "Closed" || item?.status === "CLOSED" ? (
                <span className="badge badge-success">Closed</span>
            ) : item?.status === "RESOLVED" ? (
                <span className="badge badge-success">Resolved</span>
            ) : item?.status === "ESCALATE" ? (
                <span className="badge badge-danger">Escalated</span>
            )
                : item?.status === "NEED-MORE-INFO" ? (
                    <span className="badge badge-warning">Need More Info</span>
                )
                    : (
                        <span className="badge badge-warning">Processing</span>
                    )
            ),
        },
        {
            Header: "Action",
            filterable: true,
            sticky: "left",
            Cell: ({ row }: any) => (<Link to={{ pathname: '/onissues', state: { tkt: row?.original.issue_id } }} className="badge badge-primary">View</Link>),
        },
    ];

    const getSellerList = async () => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getsellerlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                // console.log(data.data)
                setSellerList(data.data);
            }
        } catch (error) {
            console.log("error", error);
        }
    }
    const inputHandler = async (e: any) => {
        var optionvalue = e.target.value;
        if (optionvalue === "") {
            fetchIssuesList();
        } else {
            let data = [...issuesList]
            setSearchList(data.filter((item: any) => item.order_details.provider_id == optionvalue));
            getcounts(optionvalue);
            setissellerselected(true)
        }
    };

    const handlerFilterOption = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const optionValue = e.target.value;
        optionValue === "" || optionValue === null ? fetchIssuesList() : getfilterOption(optionValue);
    };


    useEffect(() => {
        fetchIssuesList();
        getSellerList();
        getgraphData();
        if (current_seller_id == 1) {
            getcounts("");
        } else {
            getcounts(sellerProviderId);
        }


    }, []);

    const [counts, setcounts] = useState({
        Closed_Tickets: 0,
        Processing_Tickets: 0,
        Resolved_Tickets: 0,
        Total_tickets: 0,
        Seller_Closed_Tickets: 0,
        Seller_Processing_Tickets: 0,
        Seller_Resolved_Tickets: 0,
        Seller_Total_Tickets: 0
    })

    const [series, setSeries] = useState([
        {
            name: 'Open Tickets',
            data: [50, 11, 10, 40]
        },
        {
            name: 'Closed Tickets',
            data: [11, 30, 40, 76]
        }
    ]);
    const [pieChartData, setpieChartData] = useState({
        "resolved": 0,
        "open": 0,
        "closed": 0,
        // "processing": 0
    })
    const [options, setOptions] = useState<any>({
        data: [
            { label: 'Resolved', value: pieChartData.resolved },
            { label: 'Open', value: pieChartData.open },
            { label: 'Closed', value: pieChartData.closed },
            // { asset: 'Processing', amount: pieChartData.processing },

        ],
        width: 300,
        series: [
            {
                type: "pie",
                angleKey: "amount",
                calloutLabelKey: "asset",
                sectorLabelKey: "amount",
                sectorLabel: {
                    color: "white",
                    fontWeight: "bold",
                    formatter: ({ value }: any) => `${(value)}`,
                },
            },
        ],

    });

    async function getcounts(sellerProviderId: string) {

        try {
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/get_tickets_count`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: { provider_id: sellerProviderId }

            });

            setcounts(data?.data);
            setpieChartData(data.data);
            setOptions((prev: any) => {
                return {
                    ...prev,
                    data: [
                        { label: 'Resolved', value: sellerProviderId === "" ? data.data.Resolved_Tickets : data.data.Seller_Resolved_Tickets },
                        { label: 'Open', value: sellerProviderId === "" ? data.data.Processing_Tickets : data.data.Seller_Processing_Tickets },
                        { label: 'Closed', value: sellerProviderId === "" ? data.data.Closed_Tickets : data.data.Seller_Closed_Tickets },
                        // { asset: 'Processing', amount: data.data.cancelled },
                    ]
                }
            })
        } catch (error) {
            console.log("error", error);
        }


    }

    console.log("options--------->", options)

    async function getgraphData() {
        let providerID;
        if (current_seller_id == 1) {
            providerID = ""
        } else {
            providerID = sellerProviderId
        }
        try {
            setIsGraphLoading(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/igm/get_ticketsby_date`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: {
                    provider_id: providerID
                }
            });
            console.log(data, "IGM 213");


            if (data?.data?.length >= 0) {
                let x = data?.data?.map((item: any) => item?.date);
                let openIssueCountArray = data?.data?.map((item: any) => item?.processingCount);
                let closedIssueCountArray = data?.data?.map((item: any) => item?.resolvedCount);

                let g = [...series];
                g[0] = { ...g[0], data: openIssueCountArray };
                g[1] = { ...g[1], data: closedIssueCountArray };

                if (x && x.length > 0) {
                    setissueDate(x);
                    setOptions((prev: any) => {
                        return { ...prev, xaxis: { ...prev.xaxis, categories: x } }
                    })

                    setSeries((prev: any) => {
                        return g
                    })
                }
            }

            setIsGraphLoading(false)
        } catch (error) {
            console.log("error", error);
            setIsGraphLoading(false)
        }


    }

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },

    }));




    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#e2e2e2",
            color: "black",
            fontSize: 12,
            fontWeight: 600,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 11,
            fontWeight: 600,

        },
    }));

    function calculateAge(creationDateString: any, closedDateString: any) {
        var currentDate: any = new Date(); // Current date and time

        // Convert creation and closed dates to Date objects
        var creationDate: any = new Date(creationDateString);
        var closedDate: any = closedDateString ? new Date(closedDateString) : null;

        // Calculate age based on whether the item is closed or not
        var age;
        if (closedDate) {
            age = closedDate - creationDate; // Duration between creation and closure
        } else {
            age = currentDate - creationDate; // Duration between creation and current date
        }

        // Convert age from milliseconds to days (or hours, minutes, etc. as needed)
        age = age / (1000 * 60 * 60 * 24); // Convert milliseconds to days

        return age;
    }



    const palette = ['#459d55', 'rebeccapurple', 'orange', '#3498db'];



    console.log("series------>", series);

    const exportIGMTickets = async () => {
        try {
            setIsExcelLoading(true);
            const response = await axios({
                url: `${baseNodeapiUrl}/igm/export_igm`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                },
                data: {},
                responseType: "blob",
            });
            const { data } = response;
            const contentType = response.headers["content-type"];
            if (contentType.includes("application/json")) {
                if (response.data?.data.length === 0) {
                    toast.success("No processing issues found. No data to export.");
                    return;
                }
            }
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "Tickets.xlsx";
            link.click();
            URL.revokeObjectURL(link.href);
            toast.success("Tickets exported successfully!");
        }
        catch (error) {
            console.log("Error in Export IGM Tickets ::", error);
        }
        finally {
            setIsExcelLoading(false);
        }
    };

    const fileChangeHandler = async (event: any) => {
        const file = event.target.files[0];
        if (!file) {
            toast.warning("Please select a file to import.");
            return;
        }
        const allowedTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'text/csv',
            'application/octet-stream'
        ];

        if (!allowedTypes.includes(file.type) && !file.name.toLowerCase().endsWith('.xlsx') && !file.name.toLowerCase().endsWith('.xls') && !file.name.toLowerCase().endsWith('.csv')) {
            toast.error("Please select a valid Excel (.xlsx, .xls) or CSV (.csv) file.");
            event.target.value = '';
            return;
        }
        const maxSize = 10 * 1024 * 1024; // 10MB
        if (file.size > maxSize) {
            toast.error("File size must be less than 10MB.");
            event.target.value = '';
            return;
        }
        setSelectedFile(file);
    };

    const importTicketsFile = async () => {
        if (!selectedFile) {
            toast.error("No file selected. Please select a file first.");
            return;
        }
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);

            const response = await axios.post(
                `${baseNodeapiUrl}/igm/import_igm`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        // Add any additional headers like authorization if needed
                        // 'Authorization': `Bearer ${yourToken}`
                    },
                }
            );

            console.log("Import successful:", response.data);
            toast.success("File imported successfully!");
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error: any) {
            console.error("Error importing tickets:", error);
            toast.error(
                error.response?.data?.message || "Failed to import file. Please try again."
            );
        }
    };

    const [showExport, setShowExport] = useState(false);

    const exportHandler = () => {
        setShowExport(true)
    }

    const [dateFilter, setDateFilter] = useState({
        startDate: "",
        endDate: ""
    })

    const dateChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setDateFilter(prev => ({
            ...prev,
            [name]: value,
        }));
    };

  const ExportHandler = async () => {
  if (!dateFilter.startDate || !dateFilter.endDate) {
    toast.error("Please select start date and end date");
    return;
  }

  try {
    const { startDate, endDate } = dateFilter;

    const response = await axios.get(
      `${nodeapiEndpoint}/export_filter_igm`,
      {
        params: { startDate, endDate },
        responseType: "blob", // 🔥 REQUIRED
      }
    );

    // ✅ Create file download
    const blob = new Blob([response.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Export_${startDate}_to_${endDate}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    setShowExport(false);
    setDateFilter({ startDate: "", endDate: "" });
    toast.success("Successfully Exported");
  } catch (error) {
    console.log("Export error", error);
    toast.error("Export failed");
  }
};



    

    return (
        <>
            <ThemeMaker>
                <div className="row w-100 m-0 mt-1" style={{}}>
                    <div className="col-md-12 p-2">
                        <div className="">
                            <div className={`d-flex flex-md-row justify-content-between ${styles.main}`}>
                                <div className={`p-3 rounded bg-white shadow border ${styles.ticketlist}`} style={{ width: "60%" }} >
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex align-items-center my-2 justify-content-between" >
                                            <div className="ticket_heading">
                                                <p className="genericlabel ps-1 m-0">Ticket List</p>
                                            </div>
                                        </div>

                                        <div className="d-flex gap-3">
                                            <button className="btn btn-primary form-control py-1 text-nowrap" onClick={exportHandler}>All Export</button>
                                            <button className={`btn btn-primary form-control py-1 mx-2 text-nowrap`} onClick={handleFOpen}>Import</button>
                                            <button className={`btn btn-primary form-control py-1 text-nowrap`} disabled={isExcelLoading} onClick={() => { exportIGMTickets() }}>{isExcelLoading ? "Exporting..." : "Export Tickets"}</button>
                                        </div>
                                    </div>

                                    {showExport && (
                                        <Modal
                                            open={showExport}
                                            onClose={()=>setShowExport(false)}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                <div className="modal-content" style={{ minHeight: "200px" }}>
                                                    <div className="modal-header d-flex justify-content-between">
                                                        <h5 className="modal-title text-dark genericlabel">
                                                            Export All Data
                                                        </h5>
                                                        <span
                                                            aria-hidden="true"
                                                            onClick={()=>setShowExport(false)}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <CloseIcon />
                                                        </span>
                                                    </div>

                                                    <div className="modal-body">
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <input
                                                                type="date"
                                                                name="startDate"
                                                                className="form-control"
                                                                onChange={dateChangeHandler}
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <input
                                                                type="date"
                                                                name="endDate"
                                                                className="form-control"
                                                                onChange={dateChangeHandler}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <div
                                                        className="modal-footer d-flex justify-content-end"
                                                        style={{ gap: "20px" }}
                                                    >
                                                        
                                                        <button
                                                            className="btn btn-primary"
                                                            type="button"
                                                            onClick={ExportHandler}
                                                        >
                                                           Export
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </Modal>
                                    )}

                                    {/* <div className="d-flex justify-content-between align-items-center"> */}
                                    <div className={`d-flex justify-content-between gap-3 my-3 ${styles.search_filter}`}>
                                        <div className="w-100">
                                            <select name="" id="" className={`form-control m-0 ${styles?.fixed_width}`} onChange={(e: any) => handlerFilterOption(e)}>
                                                <option value="" disabled selected>Search By</option>
                                                <option value="" >Search All</option>
                                                <option value="PROCESSING">Processing</option>
                                                <option value="RESOLVED">Resolved</option>
                                                <option value="CLOSED">Closed</option>
                                            </select>
                                        </div>
                                        <div className="w-100 mx-2">
                                            {current_seller_id === 1 ? (
                                                <select name="" id="" className={`form-control m-0 ${styles?.fixed_width}`} onChange={(e: any) => inputHandler(e)}>
                                                    <option value="" disabled selected>Select Seller</option>
                                                    {sellerList.map((item: any) => (
                                                        <option value={item.provider_id}>{item?.company_name}</option>
                                                    ))}
                                                </select>
                                            ) : null}
                                        </div>
                                        <div className="w-100">
                                            <input
                                                type="search"
                                                className={`form-control m-0 ${styles?.fixed_width}`}
                                                placeholder="Enter Ticket ID"
                                                onChange={((e)=>setSearchText(e.target.value))}
                                            />
                                        </div>
                                    </div>
                                    {/* </div> */}

                                    <div style={{ height: "70vh", overflow: "scroll" }}>
                                        {!isLoading ? <TableContainer component={Paper}   >
                                            <Table sx={{ minWidth: 500 }} aria-label="customized table" >
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell>Serial No.</StyledTableCell>
                                                        <StyledTableCell>Ticket ID</StyledTableCell>
                                                        <StyledTableCell>Order Id</StyledTableCell>
                                                        <StyledTableCell align="center">Status</StyledTableCell>
                                                        <StyledTableCell>Issue Created Date</StyledTableCell>
                                                        <StyledTableCell>Ageing</StyledTableCell>
                                                        <StyledTableCell align="center">Category</StyledTableCell>
                                                        <StyledTableCell align="center">Sub Category</StyledTableCell>
                                                        <StyledTableCell align="center">Closed Date</StyledTableCell>
                                                        <StyledTableCell align="center">Action</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {SearchList.length > 0 ? <>{SearchList.map((row: any, index: number) => {
                                                        const creationDate = row?.created_at;
                                                        const closedDate = row?.closed_time;
                                                        const age = calculateAge(creationDate, closedDate);
                                                        return <StyledTableRow key={row.issue_id}>
                                                            <StyledTableCell >
                                                                {(nextstep - 1) * 10 + index + 1}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {row.issue_id}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {row?.order_id}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">{row.status === "RESOLVED" ? <span className="badge badge-success" >{row.status}</span> : <span className="badge badge-warning" >{row.status}</span>}</StyledTableCell>
                                                            <StyledTableCell >
                                                                {row.created_at ? moment(row.created_at).format("DD-MM-YYYY hh:mm:ss") : ""}
                                                            </StyledTableCell>
                                                            <StyledTableCell >
                                                                {Math.ceil(age)}
                                                            </StyledTableCell>
                                                            <StyledTableCell align="center">{row.category}</StyledTableCell>
                                                            <StyledTableCell align="center">{row.sub_category}</StyledTableCell>
                                                            <StyledTableCell align="center">{row.closed_time ? moment(row.closed_time).format("DD-MM-YYYY hh:mm:ss") : ""}</StyledTableCell>
                                                            <StyledTableCell align="center"  > <Link to={{ pathname: '/onissues', state: { tkt: row?.issue_id } }} className=""> <img src={eye} alt="" width={25} height={25} style={{ cursor: "pointer" }} /> </Link></StyledTableCell>
                                                        </StyledTableRow>
                                                    })}</> : <p style={{ width: "200px" }}>No Tickets Yet!!</p>}
                                                </TableBody>
                                              
                                            </Table>
                                             
                                        </TableContainer> : <div className="d-flex  justify-content-center align-items-center" style={{ height: "100%" }}><CircularProgress /></div>}
                                       <div className="d-flex justify-content-center align-center">
                                            <div className="d-flex justify-content-center mt-3">
                                                <ul className="pagination">
                                                    {/* First Button */}
                                                    <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => {
                                                                setnextstep(1);
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === 1}
                                                        >
                                                            First
                                                        </button>
                                                    </li>

                                                    {/* Previous Button */}
                                                    <li className={`page-item ${nextstep === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => {
                                                                setnextstep(prev => Math.max(prev - 1, 1));
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === 1}
                                                        >
                                                            Previous
                                                        </button>
                                                    </li>

                                                    {/* Page Numbers - Only show when showPages is true */}
                                                    {showPages && totalPages > 1 && (() => {
                                                        const pages = [];
                                                        const maxVisible = 5;
                                                        const current = nextstep;

                                                        // Always show first page
                                                        if (current > 3) {
                                                            pages.push(
                                                                <li key="first" className="page-item">
                                                                    <button className="page-link" onClick={() => setnextstep(1)}>1</button>
                                                                </li>
                                                            );
                                                            if (current > 4) {
                                                                pages.push(
                                                                    <li key="ellipsis1" className="page-item disabled">
                                                                        <span className="page-link">...</span>
                                                                    </li>
                                                                );
                                                            }
                                                        }

                                                        // Show current page and 2 pages around it
                                                        const startPage = Math.max(1, current - 2);
                                                        const endPage = Math.min(totalPages, current + 2);

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pages.push(
                                                                <li
                                                                    key={i}
                                                                    className={`page-item ${nextstep === i ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => setnextstep(i)}
                                                                    >
                                                                        {i}
                                                                    </button>
                                                                </li>
                                                            );
                                                        }

                                                        // Always show last page
                                                        if (current < totalPages - 2) {
                                                            if (current < totalPages - 3) {
                                                                pages.push(
                                                                    <li key="ellipsis2" className="page-item disabled">
                                                                        <span className="page-link">...</span>
                                                                    </li>
                                                                );
                                                            }
                                                            pages.push(
                                                                <li key="last" className={`page-item ${nextstep === totalPages ? 'active' : ''}`}>
                                                                    <button className="page-link" onClick={() => setnextstep(totalPages)}>
                                                                        {totalPages}
                                                                    </button>
                                                                </li>
                                                            );
                                                        }

                                                        return pages;
                                                    })()}

                                                    {/* Next Button */}
                                                    <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => {
                                                                setnextstep(prev => Math.min(prev + 1, totalPages));
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === totalPages}
                                                        >
                                                            Next
                                                        </button>
                                                    </li>

                                                    {/* Last Button */}
                                                    <li className={`page-item ${nextstep === totalPages ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => {
                                                                setnextstep(totalPages);
                                                                setShowPages(true); // Show pages when navigating
                                                            }}
                                                            disabled={nextstep === totalPages}
                                                        >
                                                            Last
                                                        </button>
                                                    </li>
                                                </ul>

                                                {/* Page Info */}
                                                {/* <div className="ms-3 d-flex align-items-center">
    <span className="text-muted">
      Page {nextstep} of {totalPages}
    </span>
  </div> */}
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <div className={`bg-white rounded shadow border p-3 d-flex flex-column ${styles.countmain}`} style={{ width: "40%" }}>

                                    <div className="d-flex justify-content-around my-1" style={{ width: "100%", flexWrap: "wrap", gap: "20px" }}>

                                        <div className={`d-flex flex-column p-2 pl-3 ${styles.mobileBoxes} `} >

                                            <AssignmentTurnedInIcon style={{ color: "blue" }} />
                                            <p className={`mt-1 mb-1 ${styles.counti}`}>{(current_seller_id == 1 && !issellerSelected) ? counts?.Total_tickets : counts.Seller_Total_Tickets}</p>
                                            <p className="m-0 p-0" style={{ fontSize: "13px", color: "grey", fontWeight: "600" }}>Total Tickets</p>
                                        </div>

                                        <div className={`d-flex flex-column p-2 pl-3 ${styles.mobileBoxes} `}>
                                            <PublishedWithChangesIcon style={{ color: "red" }} />
                                            <p className={`mt-1 mb-1 ${styles.counti}`}>{(current_seller_id == 1 && !issellerSelected) ? counts.Processing_Tickets : counts?.Seller_Processing_Tickets}</p>
                                            <p className="m-0 p-0" style={{ fontSize: "13px", color: "grey", fontWeight: "600" }}>Open Tickets</p>
                                        </div>

                                        <div className={`d-flex flex-column p-2 pl-3 ${styles.mobileBoxes} `}>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <p className={`mt-1 mb-1 ${styles.counti}`}>{(current_seller_id == 1 && !issellerSelected) ? counts?.Closed_Tickets : counts?.Seller_Closed_Tickets}</p>
                                            <p className="m-0 p-0" style={{ fontSize: "13px", color: "grey", fontWeight: "600" }}>Closed Tickets</p>
                                        </div>

                                        <div className={`d-flex flex-column p-2 pl-3 ${styles.mobileBoxes} `}>
                                            <HowToRegIcon style={{ color: "lightgreen" }} />
                                            <p className={`mt-1 mb-1 ${styles.counti}`}>{(current_seller_id == 1 && !issellerSelected) ? counts?.Resolved_Tickets : counts?.Seller_Resolved_Tickets}</p>
                                            <p className="m-0 p-0" style={{ fontSize: "13px", color: "grey", fontWeight: "600" }}>Resolved Tickets</p>
                                        </div>
                                    </div>

                                    {options?.data.some((item: any) => item.amount !== 0) && <>  <PieChart
                                        colors={palette}
                                        series={[
                                            {
                                                data: options?.data,
                                                // cx: 500,
                                                // cy: 200,
                                                innerRadius: 40,
                                                outerRadius: 80,


                                            },
                                        ]}
                                        width={500}
                                        height={200}

                                        slotProps={{
                                            legend: { hidden: true },
                                        }}

                                    />
                                        <div className="d-flex mt-2 justify-content-center" style={{ gap: "20px" }}>
                                            <div className="d-flex " style={{ gap: "10px" }}>
                                                <div className={styles.colourCode} style={{ background: "rgb(69, 157, 85)" }}></div>
                                                <p>Resolved</p>

                                            </div>
                                            <div className="d-flex " style={{ gap: "10px" }}>
                                                <div className={styles.colourCode} style={{ background: "orange" }}></div>
                                                <p>Closed</p>
                                            </div>
                                            <div className="d-flex " style={{ gap: "10px" }}>
                                                <div className={styles.colourCode} style={{ background: "#663399" }}></div>
                                                <p>Open</p>
                                            </div>

                                        </div>
                                    </>}

                                </div>


                            </div>

                        </div>
                    </div>
                </div>
                <Modal open={Fopen}
                    onClose={handleFClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">


                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content" style={{ minHeight: "200px" }}>
                            <div className="modal-header d-flex justify-content-between">
                                <h5 className="modal-title text-dark genericlabel" id="exampleModalLongTitle"> Import Tickets </h5>
                                <span aria-hidden="true" onClick={handleFClose} style={{ cursor: "pointer" }} ><CloseIcon /></span>
                            </div>


                            <div className="modal-body w-75" >
                                <div className="d-flex">
                                    <div>
                                        <label >Select File</label>
                                        <input name="importTickets" type="file" className="form-control px-1" style={{ cursor: "pointer", paddingTop: '3px' }} ref={fileInputRef} onChange={fileChangeHandler} />
                                    </div>
                                </div>

                            </div>

                            <div className="modal-header d-flex justify-content-end " style={{ gap: "20px" }}>
                                <button className="btn btn-danger" data-dismiss="modal" aria-label="Close" onClick={() => {
                                    // window.location.reload()
                                    handleFClose();
                                }} >Close</button>
                                <button className="btn btn-primary" type="button" onClick={importTicketsFile}>Import</button>
                            </div>


                        </div>
                    </div>


                </Modal >
            </ThemeMaker>
        </>
    )
}

export default Issues;